import { get, post, put } from 'api/request';
import urls from 'configs/urls';

export const getAdvertisersList = ({ data }) =>
  get(null, false, urls.advertisersUrls.getAdvertisersList, data);

export const addAdvertiser = ({ data }) =>
  post(null, false, urls.advertisersUrls.addAdvertiser, data);

export const editAdvertiser = ({ advertiserKey, data }) =>
  put(null, false, `${urls.advertisersUrls.addAdvertiser}/${advertiserKey}`, data);
